import '../../styles/css/Dashboard.css';

import { Fragment, useRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import {
  getAttachmentFile,
  uploadAttachment,
} from '../../actions/uploadAttachment';
import { allowedInstructionFormats } from '../../constants/globals';
import { userActions } from '../../constants/user-actions';
import { useModalToggle } from '../../hooks/useModalToggle';
import AttachmentForm from '../Attachment/AttachmentForm';
import CustomButton from '../Reusable/CustomButton';
import CustomModal from '../Reusable/Modal/CustomModal';

const InfoCard = (props) => {
  const { title, Paragraphs, Buttons, Modal, NotificationMessages, Errors } =
      props?.t || {},
    {
      firstParagraph,
      secondParagraph,
      thirdParagraph,
      fourthParagraph,
      fifthParagraph,
      sixthParagraph,
      seventhParagraph,
      eighthParagraph,
      ninthParagraph,
    } = Paragraphs || {};

  const dispatch = useDispatch();
  const submitRef = useRef();

  const loggedUserReducer = useSelector((state) => state.loggedUserReducer),
    { allowedActions } = loggedUserReducer || {};

  const allowredActionDownload = allowedActions?.includes(
    userActions.UPLOAD_INSTRUCTION
  );

  const [showModal, toggleModal] = useModalToggle(false);

  const onSubmitHandler = (formData) => {
    dispatch(uploadAttachment(formData, NotificationMessages, toggleModal));
  };

  const onDownloadHandler = () => {
    dispatch(getAttachmentFile(NotificationMessages));
  };

  return (
    <Fragment>
      <Card md={5}>
        <Card.Header className="pt-3 pb-2 info-card-header">
          <InfoOutlinedIcon className="info-card-header-icon" />
          {title}
        </Card.Header>
        <Card.Body>
          <p>{firstParagraph}</p>
          <p>{secondParagraph}</p>
          <p>{thirdParagraph}</p>
          <p>{fourthParagraph}</p>
          <p>{fifthParagraph}</p>
          <p>{sixthParagraph}</p>
          <p>{seventhParagraph}</p>
          <p>{eighthParagraph}</p>
          <p>{ninthParagraph}</p>
          <Row className="mt-4">
            <Col md={8}>
              <CustomButton
                className={'default-btn-primary'}
                label={Buttons?.openPdf}
                startIcon={
                  <PictureAsPdfIcon
                    fontSize="small"
                    className="info-card-file-icon"
                  />
                }
                type="button"
                size={'small'}
                onClick={onDownloadHandler}
              />
            </Col>
            {allowredActionDownload && (
              <Col md={4} className="text-end">
                <CustomButton
                  className={'default-btn-primary'}
                  label={Buttons?.editPdf}
                  startIcon={<i className="fa-solid fa-upload"></i>}
                  type="button"
                  onClick={toggleModal}
                  size="small"
                />
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
      {showModal && (
        <CustomModal
          show={showModal}
          hideModal={toggleModal}
          submitRef={submitRef}
          title={Modal?.title}
          saveButtonClassName={'h-36'}
        >
          <AttachmentForm
            submitRef={submitRef}
            onSubmit={onSubmitHandler}
            Errors={Errors}
            allowedFileTypes={allowedInstructionFormats}
          />
        </CustomModal>
      )}
    </Fragment>
  );
};

export default InfoCard;
